import React, { useState } from 'react';
import parse from 'html-react-parser';
import { seoUrlParser } from '../../utils/helper';

type Props = {
    description?: string | null | undefined;
};

const Description = ({ description }: Props) => {
    const [readMore, setReadMore] = useState(false);
    return (
        <>
            {description && (
                <>
                    <div
                        className={`taxonomy-description-wrapper  mx-5 xl:mx-0${
                            readMore === false ? '' : 'line-clamp-5'
                        }`}
                    >
                        {parse(seoUrlParser(description))}
                    </div>
                    <button
                        className={` text-sm border border-brand-primary uppercase text-brand-primary font-semibold py-2 px-4 hover:bg-brand-primary hover:text-white object-right ${
                            readMore === false ? 'hidden' : ''
                        }`}
                        onClick={() => setReadMore((prev) => !prev)}
                    >
                        Read more...
                    </button>
                </>
            )}
        </>
    );
};

export default Description;
